import LogoSpinner from 'common/components/logoSpinner/LogoSpinner';
import { useStores } from 'common/hooks/useStores';
import Cookies from 'js-cookie';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import Auth from './Auth';

const Callback = () => {
    const navigate = useNavigate();
    const authStore = useStores().authStore;

    async function callback() {
        const auth = new Auth();

        try {
            const { route, token, ttl } = await auth.handleAuthentication('authweb');

            if (token && ttl) {
                authStore.setAuthToken(token);
                authStore.setAuthTTL(ttl);
                authStore.setSsoLogoutUrl(authStore.settings?.dattoSsoLogoutUrl || null);
                Cookies.set('loginType', 'authweb', { expires: 1, domain: 'infocyte.com' });
            }

            navigate(route);
        } catch (err: any) {
            navigate({
                pathname: '/login',
                state: { error: err.message }
            });
        }
    }

    useEffect(() => {
        callback();
    }, []);

    return <LogoSpinner />;
};

export default observer(Callback);
